import { items } from "@wix/data";
import { productsV3 } from "@wix/stores";

export class ProductRepository {
    constructor(args) {
        this._collectionId = args.isV1Catalog ? 'Stores/Products' : 'StoresV3/Product'
        this._isV1Catalog = args.isV1Catalog
    }

    async getAll() {
        if (this._isV1Catalog) {
            return items.query(this._collectionId).find();
        } else {
            const res = await productsV3.queryProducts({
                fields: ['CURRENCY', 'MEDIA_ITEMS_INFO']
            }).find();
            return {
                ...res,
                items: this._transformCatalogV3Data(res.items)
            }
        }
    }

    /**
     * check if any of these contains
     * sku & name must be presented together
     *
     * @param {object} args
     * @param {object} args.filter
     * @param {{
     *  sku: string | undefined,
     *  name: string | undefined
     * } | undefined} args.filter.contains
     * @param {{
     *  id: string[] | undefined
     * } | undefined} args.filter.hasSome
     * @param {number} args.page
     */
    async getPageByFilter(args) {
        console.log("ProductRepository:getPageByFilter:args", args);

        let query = items.query(this._collectionId);
        let hasFilters = false;

        if (args.filter.contains?.name) {
            query = query.contains("name", args.filter.contains.name);
            hasFilters = true;
        }

        if (args.filter.contains?.sku) {
            if (!hasFilters) {
                query = query.contains("sku", args.filter.contains.sku);
            } else {
                query = query.or(query.contains("sku", args.filter.contains.sku));
            }

            hasFilters = true;
        }

        if (args.filter.hasSome?.id && args.filter.hasSome.id.length > 0) {
            if (!hasFilters) {
                console.log(
                    "ProductRepository:getPageByFilter:hasSome",
                    args.filter.hasSome.id
                );
                query = query.hasSome("_id", args.filter.hasSome.id);
            } else {
                console.log(
                    "ProductRepository:getPageByFilter:and:hasSome",
                    args.filter.hasSome.id
                );
                query = query.and(query.hasSome("_id", args.filter.hasSome.id));
            }
        }

        console.log("ProductRepository:getPageByFilter:query", query);

        return query
            .limit(50)
            .skip(args.page * 50)
            .descending("name")
            .find();
    }

    async getPageByFilter_V3(args) {
        try {
            console.log("ProductRepository:getPageByFilter_V3:args", args);

            let query = {};
            const name = args.filter?.contains?.name?.trim?.();
            const produdctIds = args.filter?.hasSome?.id ?? [];
            const page = args.page ?? 0;

            if (name) {
                query.search = {
                    expression: name,
                    fields: ["name"],
                    fuzzy: false,
                    mode: "OR"
                };
            }

            if (produdctIds.length){
                query.filter= {
                    _id: { $in: produdctIds }
                }
            }

            let cursorToFetch = "";
            let result;
            let currentPage = 0;

            while (true) {
                query.cursorPaging = {
                    cursor: cursorToFetch,
                    limit: 50
                };

                console.log("QUERY", query);
                console.log("PAGE", currentPage, page);

                result = await productsV3.searchProducts(query, {
                    fields: ['CURRENCY', 'MEDIA_ITEMS_INFO']
                });

                const nextCursor = result?.pagingMetadata?.cursors?.next;
                console.log("NEXTCURSOR", nextCursor);

                if (currentPage === page || !nextCursor) {
                    console.log("BREAK THE LOOP");
                    break;
                }

                cursorToFetch = nextCursor;
                currentPage++;
            }


            console.log("ProductRepository:getPageByFilter_V3:RES", result);

            return {
                ...result,
                items: this._transformCatalogV3Data(result.products)
            };

        } catch (error) {
            console.error("getPageByFilter_V3 error:", error);
            return {
                items: []
            };
        }
    }

    getDummyProduct() {
        return {
            seoData: null,
            inStock: true,
            weight: 0,
            name: "Example product",
            sku: "0007",
            formattedDiscountedPrice: "85,00 €",
            productOptions: {
                Color: {
                    optionType: "color",
                    name: "Color",
                    choices: [{
                            inStock: true,
                            visible: true,
                            mainMedia: null,
                            description: "White",
                            mediaItems: [],
                            value: "#CBCBCB",
                        },
                        {
                            inStock: true,
                            visible: true,
                            mainMedia: null,
                            description: "Black",
                            mediaItems: [],
                            value: "#666666",
                        },
                    ],
                },
                Size: {
                    optionType: "size",
                    name: "Size",
                    choices: [{
                            inStock: true,
                            visible: true,
                            mainMedia: null,
                            description: "Large",
                            mediaItems: [],
                            value: "L",
                        },
                        {
                            inStock: true,
                            visible: true,
                            mainMedia: null,
                            description: "Medium",
                            mediaItems: [],
                            value: "M",
                        },
                        {
                            inStock: true,
                            visible: true,
                            mainMedia: null,
                            description: "Small",
                            mediaItems: [],
                            value: "S",
                        },
                    ],
                },
            },
            _id: "b2aa9b56-ca46-4b57-4f5b-f0a752b88610",
            discountedPrice: 85,
            formattedPrice: "85,00 €",
            price: 85,
            slug: "beanie",
            productType: "physical",
            discount: {
                type: "NONE",
                value: 0,
            },
            createdDate: "2023-08-22T12:03:55.586Z",
        };
    }

    /**
     * @param {string} slug
     */
    async findFirstBySlug(slug) {
        const products = await items
            .query(this._collectionId)
            .eq("slug", slug)
            .find();

        console.log("products", slug, products);

        return products.items[0] ?? null;
    }

    /**
     * @param {string} id
     */
    async findFirstById(id) {
        const products = await items
            .query(this._collectionId)
            .eq("_id", id)
            .find();

        console.log("products", id, products);

        return products.items[0] ?? null;
    }

    async findFirstById_V3(id) {
        const response = await productsV3.getProduct(id, {
            "fields": ["CURRENCY", "MEDIA_ITEMS_INFO"]
        });
        const transformProduct = this._transformCatalogV3Data([response])
        return transformProduct[0] ?? null
    }

    _generateManyItems() {
        return {
            items: [{
                    seoData: null,
                    inStock: true,
                    weight: 0,
                    name: "Example product",
                    sku: "0007",
                    formattedDiscountedPrice: "85,00 €",
                    productOptions: {
                        Color: {
                            optionType: "color",
                            name: "Color",
                            choices: [{
                                    inStock: true,
                                    visible: true,
                                    mainMedia: null,
                                    description: "White",
                                    mediaItems: [],
                                    value: "#CBCBCB",
                                },
                                {
                                    inStock: true,
                                    visible: true,
                                    mainMedia: null,
                                    description: "Black",
                                    mediaItems: [],
                                    value: "#666666",
                                },
                            ],
                        },
                        Size: {
                            optionType: "size",
                            name: "Size",
                            choices: [{
                                    inStock: true,
                                    visible: true,
                                    mainMedia: null,
                                    description: "Large",
                                    mediaItems: [],
                                    value: "L",
                                },
                                {
                                    inStock: true,
                                    visible: true,
                                    mainMedia: null,
                                    description: "Medium",
                                    mediaItems: [],
                                    value: "M",
                                },
                                {
                                    inStock: true,
                                    visible: true,
                                    mainMedia: null,
                                    description: "Small",
                                    mediaItems: [],
                                    value: "S",
                                },
                            ],
                        },
                    },
                    mainMedia: "wix:image://v1/c837a6_b327532c9f234dc0b357e3ba166dce1b~mv2.jpg/file.jpg#originWidth=2500&originHeight=2500",
                    description: "I'm a product description. I'm a great place to add more details about your product such as sizing, material, care instructions and cleaning instructions.",
                    _id: "b2aa9b56-ca46-4b57-4f5b-f0a752b88610",
                    discountedPrice: 85,
                    formattedPrice: "85,00 €",
                    price: 85,
                    quantityInStock: null,
                    collections: null,
                    inventoryItem: "4d5564a9-35b9-b4a8-b0a4-0f58ad4779ef",
                    _updatedDate: "2023-08-23T07:50:38.901Z",
                    formattedPricePerUnit: null,
                    slug: "beanie",
                    productType: "physical",
                    brand: null,
                    ribbons: [],
                    pricePerUnitData: null,
                    mediaItems: [{
                        description: "",
                        id: "c837a6_b327532c9f234dc0b357e3ba166dce1b~mv2.jpg",
                        link: null,
                        src: "wix:image://v1/c837a6_b327532c9f234dc0b357e3ba166dce1b~mv2.jpg/file.jpg#originWidth=2500&originHeight=2500",
                        title: "beanie (1).jpg",
                        type: "Image",
                    }, ],
                    trackInventory: false,
                    customTextFields: [],
                    pricePerUnit: null,
                    ribbon: "",
                    currency: "EUR",
                    productPageUrl: "/product-page/beanie",
                    numericId: "1692705835586000",
                    manageVariants: false,
                    discount: {
                        type: "NONE",
                        value: 0,
                    },
                    additionalInfoSections: [{
                            title: "PRODUCT INFO",
                            description: "I'm a product detail. I'm a great place to add more information about your product such as sizing, material, care and cleaning instructions. This is also a great space to write what makes this product special and how your customers can benefit from this item.",
                        },
                        {
                            title: "RETURN & REFUND POLICY",
                            description: "I’m a Return and Refund policy. I’m a great place to let your customers know what to do in case they are dissatisfied with their purchase. Having a straightforward refund or exchange policy is a great way to build trust and reassure your customers that they can buy with confidence.",
                        },
                        {
                            title: "SHIPPING INFO",
                            description: "I'm a shipping policy. I'm a great place to add more information about your shipping methods, packaging and cost. Providing straightforward information about your shipping policy is a great way to build trust and reassure your customers that they can buy from you with confidence.",
                        },
                    ],
                    createdDate: "2023-08-22T12:03:55.586Z",
                },
                {
                    seoData: null,
                    inStock: true,
                    weight: 0,
                    name: "CAP HAT",
                    sku: "0004",
                    formattedDiscountedPrice: "85,00 €",
                    productOptions: {},
                    mainMedia: "wix:image://v1/c837a6_1a901611b819444595b7ad2503e85d92~mv2.jpg/file.jpg#originWidth=2000&originHeight=2000",
                    description: "I'm a product description. I'm a great place to add more details about your product such as sizing, material, care instructions and cleaning instructions.",
                    _id: "061565f6-2063-82f5-49b5-2de1c9b527c8",
                    discountedPrice: 85,
                    formattedPrice: "85,00 €",
                    price: 85,
                    quantityInStock: null,
                    collections: null,
                    inventoryItem: "f9ea9a09-df9c-7d0a-b64a-d21e364ad837",
                    _updatedDate: "2023-08-23T07:50:38.901Z",
                    formattedPricePerUnit: null,
                    slug: "cap-hat",
                    productType: "physical",
                    brand: null,
                    ribbons: [],
                    pricePerUnitData: null,
                    mediaItems: [{
                        description: "",
                        id: "c837a6_1a901611b819444595b7ad2503e85d92~mv2.jpg",
                        link: null,
                        src: "wix:image://v1/c837a6_1a901611b819444595b7ad2503e85d92~mv2.jpg/file.jpg#originWidth=2000&originHeight=2000",
                        title: "hatArtboard 1.jpg",
                        type: "Image",
                    }, ],
                    trackInventory: false,
                    customTextFields: [],
                    pricePerUnit: null,
                    ribbon: "",
                    currency: "EUR",
                    productPageUrl: "/product-page/cap-hat",
                    numericId: "1692705192378000",
                    manageVariants: false,
                    discount: {
                        type: "NONE",
                        value: 0,
                    },
                    additionalInfoSections: [{
                            title: "PRODUCT INFO",
                            description: "I'm a product detail. I'm a great place to add more information about your product such as sizing, material, care and cleaning instructions. This is also a great space to write what makes this product special and how your customers can benefit from this item.",
                        },
                        {
                            title: "RETURN & REFUND POLICY",
                            description: "I’m a Return and Refund policy. I’m a great place to let your customers know what to do in case they are dissatisfied with their purchase. Having a straightforward refund or exchange policy is a great way to build trust and reassure your customers that they can buy with confidence.",
                        },
                        {
                            title: "SHIPPING INFO",
                            description: "I'm a shipping policy. I'm a great place to add more information about your shipping methods, packaging and cost. Providing straightforward information about your shipping policy is a great way to build trust and reassure your customers that they can buy from you with confidence.",
                        },
                    ],
                    createdDate: "2023-08-22T11:53:12.378Z",
                },
                {
                    seoData: {
                        tags: [],
                        settings: {
                            preventAutoRedirect: true,
                            keywords: [],
                        },
                    },
                    inStock: true,
                    weight: 0,
                    name: "PANNY PACK",
                    sku: "0009",
                    formattedDiscountedPrice: "85,00 €",
                    productOptions: {},
                    mainMedia: "wix:image://v1/c837a6_2b1144abbc5d4ebeb3d75db158bac2b5~mv2.jpg/file.jpg#originWidth=2869&originHeight=2869",
                    description: "I'm a product description. I'm a great place to add more details about your product such as sizing, material, care instructions and cleaning instructions.",
                    _id: "c7d4c7f8-e101-bf3c-54a6-d42eed7da3cf",
                    discountedPrice: 85,
                    formattedPrice: "85,00 €",
                    price: 85,
                    quantityInStock: null,
                    collections: null,
                    inventoryItem: "382b3807-1efe-40c3-ab59-2bd112825c30",
                    _updatedDate: "2023-11-26T08:38:01.843Z",
                    formattedPricePerUnit: null,
                    slug: "panny-pack",
                    productType: "physical",
                    brand: null,
                    ribbons: [],
                    pricePerUnitData: null,
                    mediaItems: [{
                        description: "",
                        id: "c837a6_2b1144abbc5d4ebeb3d75db158bac2b5~mv2.jpg",
                        link: null,
                        src: "wix:image://v1/c837a6_2b1144abbc5d4ebeb3d75db158bac2b5~mv2.jpg/file.jpg#originWidth=2869&originHeight=2869",
                        title: "fanny packArtboard 1 (1).jpg",
                        type: "Image",
                    }, ],
                    trackInventory: false,
                    customTextFields: [],
                    pricePerUnit: null,
                    ribbon: "",
                    currency: "EUR",
                    productPageUrl: "/product-page/panny-pack",
                    numericId: "1692706340480000",
                    manageVariants: false,
                    discount: {
                        type: "NONE",
                        value: 0,
                    },
                    additionalInfoSections: [{
                            title: "PRODUCT INFO",
                            description: "I'm a product detail. I'm a great place to add more information about your product such as sizing, material, care and cleaning instructions. This is also a great space to write what makes this product special and how your customers can benefit from this item.",
                        },
                        {
                            title: "RETURN & REFUND POLICY",
                            description: "I’m a Return and Refund policy. I’m a great place to let your customers know what to do in case they are dissatisfied with their purchase. Having a straightforward refund or exchange policy is a great way to build trust and reassure your customers that they can buy with confidence.",
                        },
                        {
                            title: "SHIPPING INFO",
                            description: "I'm a shipping policy. I'm a great place to add more information about your shipping methods, packaging and cost. Providing straightforward information about your shipping policy is a great way to build trust and reassure your customers that they can buy from you with confidence.",
                        },
                    ],
                    createdDate: "2023-08-22T12:12:20.480Z",
                },
                {
                    seoData: null,
                    inStock: true,
                    weight: 0,
                    name: "PHONE CASE",
                    sku: "0006",
                    formattedDiscountedPrice: "85,00 €",
                    productOptions: {},
                    mainMedia: "wix:image://v1/c837a6_234cf68ebb2e4d2bb6f7370fffacec9d~mv2.jpg/file.jpg#originWidth=2500&originHeight=2500",
                    description: "I'm a product description. I'm a great place to add more details about your product such as sizing, material, care instructions and cleaning instructions.",
                    _id: "97519ad8-84df-24b6-2c33-b2c58517b6d4",
                    discountedPrice: 85,
                    formattedPrice: "85,00 €",
                    price: 85,
                    quantityInStock: null,
                    collections: null,
                    inventoryItem: "68ae6527-7b20-db49-d3cc-4d3a7ae8492b",
                    _updatedDate: "2023-08-23T07:50:38.901Z",
                    formattedPricePerUnit: null,
                    slug: "phone-case",
                    productType: "physical",
                    brand: null,
                    ribbons: [],
                    pricePerUnitData: null,
                    mediaItems: [{
                        description: "",
                        id: "c837a6_234cf68ebb2e4d2bb6f7370fffacec9d~mv2.jpg",
                        link: null,
                        src: "wix:image://v1/c837a6_234cf68ebb2e4d2bb6f7370fffacec9d~mv2.jpg/file.jpg#originWidth=2500&originHeight=2500",
                        title: "phone case.jpg",
                        type: "Image",
                    }, ],
                    trackInventory: false,
                    customTextFields: [],
                    pricePerUnit: null,
                    ribbon: "",
                    currency: "EUR",
                    productPageUrl: "/product-page/phone-case",
                    numericId: "1692705637197000",
                    manageVariants: false,
                    discount: {
                        type: "NONE",
                        value: 0,
                    },
                    additionalInfoSections: [{
                            title: "PRODUCT INFO",
                            description: "I'm a product detail. I'm a great place to add more information about your product such as sizing, material, care and cleaning instructions. This is also a great space to write what makes this product special and how your customers can benefit from this item.",
                        },
                        {
                            title: "RETURN & REFUND POLICY",
                            description: "I’m a Return and Refund policy. I’m a great place to let your customers know what to do in case they are dissatisfied with their purchase. Having a straightforward refund or exchange policy is a great way to build trust and reassure your customers that they can buy with confidence.",
                        },
                        {
                            title: "SHIPPING INFO",
                            description: "I'm a shipping policy. I'm a great place to add more information about your shipping methods, packaging and cost. Providing straightforward information about your shipping policy is a great way to build trust and reassure your customers that they can buy from you with confidence.",
                        },
                    ],
                    createdDate: "2023-08-22T12:00:37.197Z",
                },
                {
                    seoData: null,
                    inStock: true,
                    weight: 0,
                    name: "PINK SWEATSHIRT",
                    sku: "0005",
                    formattedDiscountedPrice: "85,00 €",
                    productOptions: {},
                    mainMedia: "wix:image://v1/c837a6_2ee08830eacc4e56ba81538da4675ff4~mv2.jpg/file.jpg#originWidth=2763&originHeight=2772",
                    description: "I'm a product description. I'm a great place to add more details about your product such as sizing, material, care instructions and cleaning instructions.",
                    _id: "c30965f9-f967-edce-8194-1b6e003b2369",
                    discountedPrice: 85,
                    formattedPrice: "85,00 €",
                    price: 85,
                    quantityInStock: null,
                    collections: null,
                    inventoryItem: "3cf69a06-0698-1231-7e6b-e491ffc4dc96",
                    _updatedDate: "2023-08-23T07:50:38.901Z",
                    formattedPricePerUnit: null,
                    slug: "pink-sweatshirt",
                    productType: "physical",
                    brand: null,
                    ribbons: [],
                    pricePerUnitData: null,
                    mediaItems: [{
                        description: "",
                        id: "c837a6_2ee08830eacc4e56ba81538da4675ff4~mv2.jpg",
                        link: null,
                        src: "wix:image://v1/c837a6_2ee08830eacc4e56ba81538da4675ff4~mv2.jpg/file.jpg#originWidth=2763&originHeight=2772",
                        title: "shirt 2Artboard 1.jpg",
                        type: "Image",
                    }, ],
                    trackInventory: false,
                    customTextFields: [],
                    pricePerUnit: null,
                    ribbon: "",
                    currency: "EUR",
                    productPageUrl: "/product-page/pink-sweatshirt",
                    numericId: "1692705518165000",
                    manageVariants: false,
                    discount: {
                        type: "NONE",
                        value: 0,
                    },
                    additionalInfoSections: [{
                            title: "PRODUCT INFO",
                            description: "I'm a product detail. I'm a great place to add more information about your product such as sizing, material, care and cleaning instructions. This is also a great space to write what makes this product special and how your customers can benefit from this item.",
                        },
                        {
                            title: "RETURN & REFUND POLICY",
                            description: "I’m a Return and Refund policy. I’m a great place to let your customers know what to do in case they are dissatisfied with their purchase. Having a straightforward refund or exchange policy is a great way to build trust and reassure your customers that they can buy with confidence.",
                        },
                        {
                            title: "SHIPPING INFO",
                            description: "I'm a shipping policy. I'm a great place to add more information about your shipping methods, packaging and cost. Providing straightforward information about your shipping policy is a great way to build trust and reassure your customers that they can buy from you with confidence.",
                        },
                    ],
                    createdDate: "2023-08-22T11:58:38.165Z",
                },
                {
                    seoData: null,
                    inStock: true,
                    weight: 0,
                    name: "POSTER",
                    sku: "0002",
                    formattedDiscountedPrice: "85,00 €",
                    productOptions: {
                        "Poster Image": {
                            optionType: "drop_down",
                            name: "Poster Image",
                            choices: [{
                                    inStock: true,
                                    visible: true,
                                    mainMedia: null,
                                    description: "Lips Poster",
                                    mediaItems: [],
                                    value: "Lips Poster",
                                },
                                {
                                    inStock: true,
                                    visible: true,
                                    mainMedia: null,
                                    description: "Tali$a Portrait",
                                    mediaItems: [],
                                    value: "Tali$a Portrait",
                                },
                            ],
                        },
                    },
                    mainMedia: "wix:image://v1/c837a6_b4b5c986dd2749b09c6cd4b42276b528~mv2.jpg/file.jpg#originWidth=2500&originHeight=2500",
                    description: "I'm a product description. I'm a great place to add more details about your product such as sizing, material, care instructions and cleaning instructions.",
                    _id: "1c29282b-5ffe-ad5c-8d37-ea9898237465",
                    discountedPrice: 85,
                    formattedPrice: "85,00 €",
                    price: 85,
                    quantityInStock: null,
                    collections: null,
                    inventoryItem: "e3d6d7d4-a001-52a3-72c8-156767dc8b9a",
                    _updatedDate: "2023-08-23T07:50:38.901Z",
                    formattedPricePerUnit: null,
                    slug: "poster",
                    productType: "physical",
                    brand: null,
                    ribbons: [],
                    pricePerUnitData: null,
                    mediaItems: [{
                            description: "",
                            id: "c837a6_b4b5c986dd2749b09c6cd4b42276b528~mv2.jpg",
                            link: null,
                            src: "wix:image://v1/c837a6_b4b5c986dd2749b09c6cd4b42276b528~mv2.jpg/file.jpg#originWidth=2500&originHeight=2500",
                            title: "POSTER.jpg",
                            type: "Image",
                        },
                        {
                            description: "",
                            id: "c837a6_f2855f289fcc49d182f8a658f6abe71e~mv2.jpg",
                            link: null,
                            src: "wix:image://v1/c837a6_f2855f289fcc49d182f8a658f6abe71e~mv2.jpg/file.jpg#originWidth=550&originHeight=551",
                            title: "POSTER 2.jpg",
                            type: "Image",
                        },
                    ],
                    trackInventory: false,
                    customTextFields: [],
                    pricePerUnit: null,
                    ribbon: "",
                    currency: "EUR",
                    productPageUrl: "/product-page/poster",
                    numericId: "1692705031889000",
                    manageVariants: false,
                    discount: {
                        type: "NONE",
                        value: 0,
                    },
                    additionalInfoSections: [{
                            title: "PRODUCT INFO",
                            description: "I'm a product detail. I'm a great place to add more information about your product such as sizing, material, care and cleaning instructions. This is also a great space to write what makes this product special and how your customers can benefit from this item.",
                        },
                        {
                            title: "RETURN & REFUND POLICY",
                            description: "I’m a Return and Refund policy. I’m a great place to let your customers know what to do in case they are dissatisfied with their purchase. Having a straightforward refund or exchange policy is a great way to build trust and reassure your customers that they can buy with confidence.",
                        },
                        {
                            title: "SHIPPING INFO",
                            description: "I'm a shipping policy. I'm a great place to add more information about your shipping methods, packaging and cost. Providing straightforward information about your shipping policy is a great way to build trust and reassure your customers that they can buy from you with confidence.",
                        },
                    ],
                    createdDate: "2023-08-22T11:50:31.889Z",
                },
                {
                    seoData: null,
                    inStock: true,
                    weight: 0,
                    name: "SWEATSHIRT",
                    sku: "0001",
                    formattedDiscountedPrice: "85,00 €",
                    productOptions: {
                        Color: {
                            optionType: "color",
                            name: "Color",
                            choices: [{
                                    inStock: true,
                                    visible: true,
                                    mainMedia: null,
                                    description: "Dark Purple",
                                    mediaItems: [],
                                    value: "#372A48",
                                },
                                {
                                    inStock: true,
                                    visible: true,
                                    mainMedia: null,
                                    description: "Pink",
                                    mediaItems: [],
                                    value: "#D50075",
                                },
                            ],
                        },
                        Size: {
                            optionType: "drop_down",
                            name: "Size",
                            choices: [{
                                    inStock: true,
                                    visible: true,
                                    mainMedia: null,
                                    description: "Small",
                                    mediaItems: [],
                                    value: "Small",
                                },
                                {
                                    inStock: true,
                                    visible: true,
                                    mainMedia: null,
                                    description: "Medium",
                                    mediaItems: [],
                                    value: "Medium",
                                },
                                {
                                    inStock: true,
                                    visible: true,
                                    mainMedia: null,
                                    description: "Large",
                                    mediaItems: [],
                                    value: "Large",
                                },
                                {
                                    inStock: true,
                                    visible: true,
                                    mainMedia: null,
                                    description: "XL",
                                    mediaItems: [],
                                    value: "XL",
                                },
                            ],
                        },
                    },
                    mainMedia: "wix:image://v1/c837a6_92b21b13a9534ad9a3874f5d980c0448~mv2.jpg/file.jpg#originWidth=2763&originHeight=2772",
                    description: "I'm a product description. I'm a great place to add more details about your product such as sizing, material, care instructions and cleaning instructions.",
                    _id: "df19c1f7-07d8-a265-42f8-e8dfa824cc6e",
                    discountedPrice: 85,
                    formattedPrice: "85,00 €",
                    price: 85,
                    quantityInStock: null,
                    collections: null,
                    inventoryItem: "20e63e08-f827-5d9a-bd07-172057db3391",
                    _updatedDate: "2023-08-23T07:50:38.901Z",
                    formattedPricePerUnit: null,
                    slug: "sweatshirt",
                    productType: "physical",
                    brand: null,
                    ribbons: [],
                    pricePerUnitData: null,
                    mediaItems: [{
                            description: "",
                            id: "c837a6_92b21b13a9534ad9a3874f5d980c0448~mv2.jpg",
                            link: null,
                            src: "wix:image://v1/c837a6_92b21b13a9534ad9a3874f5d980c0448~mv2.jpg/file.jpg#originWidth=2763&originHeight=2772",
                            title: "shirtArtboard 1.jpg",
                            type: "Image",
                        },
                        {
                            description: "",
                            id: "c837a6_2ee08830eacc4e56ba81538da4675ff4~mv2.jpg",
                            link: null,
                            src: "wix:image://v1/c837a6_2ee08830eacc4e56ba81538da4675ff4~mv2.jpg/file.jpg#originWidth=2763&originHeight=2772",
                            title: "shirt 2Artboard 1.jpg",
                            type: "Image",
                        },
                    ],
                    trackInventory: false,
                    customTextFields: [],
                    pricePerUnit: null,
                    ribbon: "",
                    currency: "EUR",
                    productPageUrl: "/product-page/sweatshirt",
                    numericId: "1462356045882000",
                    manageVariants: false,
                    discount: {
                        type: "NONE",
                        value: 0,
                    },
                    additionalInfoSections: [{
                            title: "PRODUCT INFO",
                            description: "I'm a product detail. I'm a great place to add more information about your product such as sizing, material, care and cleaning instructions. This is also a great space to write what makes this product special and how your customers can benefit from this item.",
                        },
                        {
                            title: "RETURN & REFUND POLICY",
                            description: "I’m a Return and Refund policy. I’m a great place to let your customers know what to do in case they are dissatisfied with their purchase. Having a straightforward refund or exchange policy is a great way to build trust and reassure your customers that they can buy with confidence.",
                        },
                        {
                            title: "SHIPPING INFO",
                            description: "I'm a shipping policy. I'm a great place to add more information about your shipping methods, packaging and cost. Providing straightforward information about your shipping policy is a great way to build trust and reassure your customers that they can buy from you with confidence.",
                        },
                    ],
                    createdDate: "2016-05-04T10:00:45.882Z",
                },
                {
                    seoData: null,
                    inStock: true,
                    weight: 0,
                    name: "THE CRYSTAL PROJECT CD EDITION",
                    sku: "0008",
                    formattedDiscountedPrice: "85,00 €",
                    productOptions: {},
                    mainMedia: "wix:image://v1/c837a6_964954e69882411bac2ae08cdc2a44e9~mv2.jpg/file.jpg#originWidth=2500&originHeight=2500",
                    description: "I'm a product description. I'm a great place to add more details about your product such as sizing, material, care instructions and cleaning instructions.",
                    _id: "795b91a1-6e39-a980-2c58-4051f7aa0bd8",
                    discountedPrice: 85,
                    formattedPrice: "85,00 €",
                    price: 85,
                    quantityInStock: null,
                    collections: null,
                    inventoryItem: "86a46e5e-91c6-567f-d3a7-bfae0855f427",
                    _updatedDate: "2023-08-23T07:50:38.901Z",
                    formattedPricePerUnit: null,
                    slug: "the-crystal-project-cd-edition",
                    productType: "physical",
                    brand: null,
                    ribbons: [],
                    pricePerUnitData: null,
                    mediaItems: [{
                        description: "",
                        id: "c837a6_964954e69882411bac2ae08cdc2a44e9~mv2.jpg",
                        link: null,
                        src: "wix:image://v1/c837a6_964954e69882411bac2ae08cdc2a44e9~mv2.jpg/file.jpg#originWidth=2500&originHeight=2500",
                        title: "cd.jpg",
                        type: "Image",
                    }, ],
                    trackInventory: false,
                    customTextFields: [],
                    pricePerUnit: null,
                    ribbon: "",
                    currency: "EUR",
                    productPageUrl: "/product-page/the-crystal-project-cd-edition",
                    numericId: "1692705880533000",
                    manageVariants: false,
                    discount: {
                        type: "NONE",
                        value: 0,
                    },
                    additionalInfoSections: [{
                            title: "PRODUCT INFO",
                            description: "I'm a product detail. I'm a great place to add more information about your product such as sizing, material, care and cleaning instructions. This is also a great space to write what makes this product special and how your customers can benefit from this item.",
                        },
                        {
                            title: "RETURN & REFUND POLICY",
                            description: "I’m a Return and Refund policy. I’m a great place to let your customers know what to do in case they are dissatisfied with their purchase. Having a straightforward refund or exchange policy is a great way to build trust and reassure your customers that they can buy with confidence.",
                        },
                        {
                            title: "SHIPPING INFO",
                            description: "I'm a shipping policy. I'm a great place to add more information about your shipping methods, packaging and cost. Providing straightforward information about your shipping policy is a great way to build trust and reassure your customers that they can buy from you with confidence.",
                        },
                    ],
                    createdDate: "2023-08-22T12:04:40.533Z",
                },
                {
                    seoData: null,
                    inStock: true,
                    weight: 0,
                    name: "THE CRYSTAL PROJECT VINYL",
                    sku: "0003",
                    formattedDiscountedPrice: "85,00 €",
                    productOptions: {},
                    mainMedia: "wix:image://v1/c837a6_984f6b13020243eaa761575c64d6ef34~mv2.jpg/file.jpg#originWidth=2500&originHeight=2500",
                    description: "I'm a product description. I'm a great place to add more details about your product such as sizing, material, care instructions and cleaning instructions.",
                    _id: "3eaa86ea-1d00-c63f-4223-358da30e59ba",
                    discountedPrice: 85,
                    formattedPrice: "85,00 €",
                    price: 85,
                    quantityInStock: null,
                    collections: null,
                    inventoryItem: "c1557915-e2ff-39c0-bddc-ca725cf1a645",
                    _updatedDate: "2023-08-23T07:50:38.901Z",
                    formattedPricePerUnit: null,
                    slug: "the-crystal-project-vinyl",
                    productType: "physical",
                    brand: null,
                    ribbons: [],
                    pricePerUnitData: null,
                    mediaItems: [{
                        description: "",
                        id: "c837a6_984f6b13020243eaa761575c64d6ef34~mv2.jpg",
                        link: null,
                        src: "wix:image://v1/c837a6_984f6b13020243eaa761575c64d6ef34~mv2.jpg/file.jpg#originWidth=2500&originHeight=2500",
                        title: "record.jpg",
                        type: "Image",
                    }, ],
                    trackInventory: false,
                    customTextFields: [],
                    pricePerUnit: null,
                    ribbon: "",
                    currency: "EUR",
                    productPageUrl: "/product-page/the-crystal-project-vinyl",
                    numericId: "1692705134511000",
                    manageVariants: false,
                    discount: {
                        type: "NONE",
                        value: 0,
                    },
                    additionalInfoSections: [{
                            title: "PRODUCT INFO",
                            description: "I'm a product detail. I'm a great place to add more information about your product such as sizing, material, care and cleaning instructions. This is also a great space to write what makes this product special and how your customers can benefit from this item.",
                        },
                        {
                            title: "RETURN & REFUND POLICY",
                            description: "I’m a Return and Refund policy. I’m a great place to let your customers know what to do in case they are dissatisfied with their purchase. Having a straightforward refund or exchange policy is a great way to build trust and reassure your customers that they can buy with confidence.",
                        },
                        {
                            title: "SHIPPING INFO",
                            description: "I'm a shipping policy. I'm a great place to add more information about your shipping methods, packaging and cost. Providing straightforward information about your shipping policy is a great way to build trust and reassure your customers that they can buy from you with confidence.",
                        },
                    ],
                    createdDate: "2023-08-22T11:52:14.511Z",
                },
            ],
            length: 9,
            partialIncludes: false,
            query: {
                invalidArguments: [],
                filterTree: {},
                encoder: {},
                provider: {
                    cloudDataUrl: "/_api/cloud-data",
                    segment: "LIVE",
                    authHeader: {},
                },
                collectionName: "Stores/Products",
                skipNumber: 0,
                included: [],
                projectedFields: [],
            },
            totalCount: 9,
            totalPages: 1,
        };
    }

    _transformCatalogV3Data(items) {
        if (!items || items.length === 0) {
            return [];
        }

        function convertProductOptions(sourceOptions) {

            if (!sourceOptions || !Array.isArray(sourceOptions) || sourceOptions.length === 0) {
                return {};
            }

            const getOptionType = (renderType, choiceType) =>
                renderType === 'SWATCH_CHOICES' && choiceType === 'ONE_COLOR' ? 'color' : 'drop_down';

            const getChoiceValue = (choice, isColor) =>
                isColor ? choice.colorCode || choice.key : choice.key || choice.name;

            return sourceOptions.reduce((acc, option) => {
                const choices = option.choicesSettings?.choices;
                if (!choices?.length) return acc;

                const isColor = getOptionType(option.optionRenderType, choices[0].choiceType) === 'color';

                acc[option.key] = {
                    optionType: isColor ? 'color' : 'drop_down',
                    name: option.name,
                    choices: choices.map(choice => ({
                        inStock: choice.inStock,
                        visible: choice.visible,
                        mainMedia: "",
                        description: choice.name,
                        mediaItems: [],
                        value: getChoiceValue(choice, isColor)
                    }))
                };

                return acc;
            }, {});
        }

        const convertedProducts = items.map(sourceProduct => {
            const seoData = {
                tags: [{
                    children: "",
                    custom: false,
                    disabled: false,
                    type: "meta",
                    props: {
                        name: "description",
                        content: "content"
                    }
                }]
            };

            const price = parseFloat(sourceProduct.actualPriceRange?.minValue?.amount) || 0;
            const formattedPrice = sourceProduct.actualPriceRange?.minValue?.formattedAmount || "";

            return {
                seoData,
                inStock: sourceProduct.inventory?.availabilityStatus === 'IN_STOCK',
                weight: sourceProduct.physicalProperties?.weight || 0,
                name: sourceProduct.name,
                sku: sourceProduct.sku || '',
                price,
                formattedPrice,
                discountedPrice: price,
                formattedDiscountedPrice: formattedPrice,
                productOptions: convertProductOptions(sourceProduct.options) || {},
                mainMedia: sourceProduct.media?.main?.image || null,
                description: sourceProduct.plainDescription || '',
                _id: sourceProduct._id,
                slug: sourceProduct.slug,
                productType: sourceProduct.productType,
                ribbon: sourceProduct.ribbon?.name || null,
                ribbons: sourceProduct.ribbon ? [{ text: sourceProduct.ribbon.name }] : [],
                mediaItems: [{
                    src: sourceProduct.media?.main?.image || null,
                    id: sourceProduct.media?.main?.uploadId || null
                }],
                currency: sourceProduct.currency,
                productPageUrl: `/product-page/${sourceProduct.slug}`,
                numericId: sourceProduct.numericId,
                manageVariants: sourceProduct.variantSummary?.variantCount > 1,
                additionalInfoSections: [],
                _updatedDate: sourceProduct._updatedDate,
                createdDate: sourceProduct._createdDate
            };
        });

        return convertedProducts;
    }
}